const dateFormat = 'MMM DD, YYYY';
const ddmmmmyyyy = 'DD MMMM YYYY';
const success = 'success';
const error = 'error';
const info = 'info';
const warning = 'warning';
const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType = 'application/wps-office.xlsx';
const OtherXlsx =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const JsonType = 'application/json';
const JsType = 'text/javascript';
const pythonDjangoType = 'text/x-python';
const DmnType = 'dmn';
const dateFormatWithHyphen = 'YYYY-MM-DD';
const png = 'png';
const jpeg = 'jpeg';
const jpg = 'jpg';
const pdf = 'pdf';
const tiff = 'tiff';
const tif = 'tif';
const zipType = 'application/zip';
const zipAltType = 'application/x-zip-compressed';
const doc = 'application/msword';
const docx =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const docType = 'doc';
const docxType = 'docx';

const constants = {
  docType,
  docxType,
  dateFormat,
  ddmmmmyyyy,
  success,
  error,
  info,
  warning,
  XlsType,
  XlsWpsType,
  XlsxType,
  CsvType,
  JsonType,
  JsType,
  pythonDjangoType,
  DmnType,
  OtherXlsx,
  dateFormatWithHyphen,
  png,
  jpeg,
  // gstTreatmentOptions,
  // msmeType,
  pdf,
  jpg,
  tif,
  tiff,
  zipType,
  zipAltType,
  doc,
  docx,
};

export default constants;
